import React, { useState } from 'react';
import { Modal, Tooltip } from 'antd';
import { ReactComponent as SettingsIcon } from 'assets/images/SVG/icons/settings-icon.svg';
import { SpanButton } from 'component/button_components/button.style';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import DomainSettings from 'component/domain_settings_component';

export default function DomainSettingsModal({ ...record }) {
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);

  const showModal = async () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
    setLoader(false);
  };
  return (
    <>
      <Tooltip title='Settings' color='#597081' className='af-domain-settings-tooltip'>
        <SpanButton onClick={showModal} className='af-domain-settings-tooltip-button'>
          <SettingsIcon className='af-domain-settings-tooltip-icon' />
        </SpanButton>
      </Tooltip>
      {loader && <ModalOpenLoader />}
      {open && (
        <Modal
          open={open}
          maskClosable={false}
          onCancel={handleCancel}
          footer={[null]}
          centered
          width={900}
          className='modal-style af-domain-settings-modal'
        >
          <DomainSettings record={record} />
        </Modal>
      )}
    </>
  );
}
